/* jenny-porst.de Relaunch 2026 */
(function () {
  var START = Date.parse('2026-11-04T00:00:00+01:00');
  var END = Date.parse('2026-11-29T23:59:59+01:00');
  var ENDSPURT = Date.parse('2026-11-27T00:00:00+01:00');
  var SHOW_FROM = Date.parse('2026-11-01T00:00:00+01:00');
  var DAY = 864e5;
  var WA = 'https://wa.me/491709220400?text=';
  var q = new URLSearchParams(location.search);
  var force = q.get('phase'); // vor | laeuft | endspurt | vorbei (nur zum Testen)

  function now() {
    var r = Date.now();
    if (force === 'vor') return START - 2 * DAY;
    if (force === 'laeuft') return START + 9 * DAY + (r % DAY);
    if (force === 'endspurt') return END - DAY + (r % 36e5);
    if (force === 'vorbei') return END + DAY;
    return r;
  }
  function pad(n) { return String(n).padStart(2, '0'); }
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }

  var LINKS = {
    before: { ctaLabel: '#formular', secondLabel: '/pages/hyla-vorfuehrung', bwCta: '/pages/hyla-black-week#formular', bwSecond: '/pages/hyla-black-week', bwBlack: '/go/black-week', bwWhite: '/go/black-week-white' },
    running: { ctaLabel: '/go/black-week', secondLabel: '/go/black-week-white', bwCta: '/go/black-week', bwSecond: '/pages/hyla-black-week#paket', bwBlack: '/go/black-week', bwWhite: '/go/black-week-white' },
    over: { ctaLabel: '#formular', secondLabel: '/pages/hyla-est', bwCta: '/pages/hyla-black-week#formular', bwSecond: '/pages/hyla-est', bwBlack: '/pages/hyla-est', bwWhite: '/pages/hyla-white-edition' }
  };

  function vals() {
    var n = now();
    var isBefore = n < START, isOver = n > END, isRunning = !isBefore && !isOver;
    var diff = isOver ? 0 : Math.max(0, (isBefore ? START : END) - n);
    var step = isBefore ? 1 : (isOver ? 4 : (n >= ENDSPURT ? 3 : 2));
    var v = {
      isBefore: isBefore, isRunning: isRunning, isOver: isOver,
      showBand: n >= SHOW_FROM && !isOver, hideBand: !(n >= SHOW_FROM && !isOver),
      step: step, phase: isBefore ? 'before' : (isOver ? 'over' : 'running'),
      bandLabel: isBefore ? 'Die Black Week startet in' : 'Die Black Week endet in',
      days: pad(Math.floor(diff / DAY)), hours: pad(Math.floor(diff % DAY / 36e5)),
      minutes: pad(Math.floor(diff % 36e5 / 6e4)), seconds: pad(Math.floor(diff % 6e4 / 1e3)),
      statusTitle: 'Die Black Week startet am 4. November.',
      statusText: 'Ab Mittwoch, 0:00 Uhr, gilt der Code BLACK. Dann öffnen Sie unten den fertigen Warenkorb, geben den Code ein und bekommen sechs Extras im Wert von 878,90 € dazu.',
      ctaLabel: 'Am Starttag erinnern lassen', secondLabel: 'Vorführung anfragen',
      heroNote: 'Ab 4. November, 0:00 Uhr, gilt der Code BLACK. Täglich von 7 bis 22 Uhr erreichbar.', orderLabel: 'Bei HYLA öffnen', orderBlack: 'Schwarz bei HYLA öffnen', orderWhite: 'Weiß bei HYLA öffnen',
      bwCta: 'Am Starttag erinnern lassen', bwSecond: 'Alle Infos zur Black Week'
    };
    if (isRunning) {
      v.statusTitle = step === 3 ? 'Endspurt: Die Black Week endet am 29. November um 23:59 Uhr.' : 'Die Black Week läuft bis 29. November, 23:59 Uhr.';
      v.statusText = 'Öffnen Sie unten den fertigen Warenkorb bei HYLA Germany, schwarz oder weiß. Geben Sie dort den Code BLACK ein und klicken Sie auf „Einlösen“. Dann Daten eintragen, Zahlungsart wählen, fertig. Lieber persönlich? Wir helfen gern am Telefon, per WhatsApp oder E-Mail.';
      v.ctaLabel = 'Schwarz bei HYLA öffnen'; v.secondLabel = 'Weiß bei HYLA öffnen';
      v.heroNote = 'Fertiger Warenkorb mit dem HYLA EST schwarz und VENTUS-Set. Code BLACK eingeben, Daten eintragen, HYLA liefert. Täglich von 7 bis 22 Uhr für Sie da.';
      v.bwCta = 'Zum fertigen Warenkorb bei HYLA'; v.bwSecond = 'Was im Paket ist';
    }
    if (isOver) {
      v.statusTitle = 'Die Black Week 2026 ist vorbei.';
      v.statusText = 'Danke für Ihr Vertrauen. Tragen Sie sich ein, dann informieren wir Sie zur nächsten Aktion.';
      v.ctaLabel = 'Für 2027 vormerken'; v.secondLabel = 'Zu den HYLA-Infos';
      v.heroNote = 'Wir sind weiter für Sie da, täglich von 7 bis 22 Uhr.';
      v.bwCta = 'Für 2027 vormerken'; v.bwSecond = 'Zu den HYLA-Infos'; v.orderLabel = 'Mehr zum HYLA'; v.orderBlack = 'Zum HYLA EST'; v.orderWhite = 'Zur White Edition';
    }
    return v;
  }

  var lastPhase = null;
  function render() {
    var v = vals();
    $$('[data-jp-v]').forEach(function (el) {
      var k = el.getAttribute('data-jp-v');
      if (k in v && el.textContent !== String(v[k])) el.textContent = v[k];
    });
    if (v.phase === lastPhase) return;
    lastPhase = v.phase;
    $$('[data-jp-if]').forEach(function (el) { el.classList.toggle('jp-hide', !v[el.getAttribute('data-jp-if')]); });
    $$('[data-jp-show]').forEach(function (el) { el.classList.toggle('jp-hide', !v[el.getAttribute('data-jp-show')]); });
    $$('a[data-jp-link]').forEach(function (a) {
      var k = a.getAttribute('data-jp-link'), h = LINKS[v.phase][k];
      if (h) {
        a.href = h;
        if (h.indexOf('http') === 0) { a.target = '_blank'; a.rel = 'noopener'; } else { a.removeAttribute('target'); if (h.indexOf('/go/') === 0) a.rel = 'nofollow'; else a.removeAttribute('rel'); }
      }
    });
    $$('[data-jp-ph]').forEach(function (el) {
      var n = +el.getAttribute('data-jp-ph');
      el.classList.toggle('is-now', n === v.step);
      el.classList.toggle('is-done', n < v.step);
      var t = el.querySelector('.jp-phtag');
      if (t && /^(Jetzt|Vorbei|Demnächst)$/.test(t.textContent.trim())) t.textContent = n === v.step ? 'Jetzt' : (n < v.step ? 'Vorbei' : 'Demnächst');
    });
  }
  render();
  setInterval(render, 1000);

  /* Videos: erst nach Klick laden (youtube-nocookie) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-yt]');
    if (!a || e.metaKey || e.ctrlKey) return;
    var box = a.querySelector('img') ? a.querySelector('img').parentNode : null;
    if (!box) return;
    e.preventDefault();
    var id = a.getAttribute('data-yt');
    var wrap = document.createElement('span');
    wrap.className = 'jp-yt';
    wrap.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0" title="Video von Jenny Porst auf YouTube" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
    var card = box.parentNode === a ? a : box;
    // Karte bleibt Karte: Bildbereich durch Player ersetzen, Link wird neutralisiert
    box.replaceWith(wrap);
    a.removeAttribute('href'); a.removeAttribute('data-yt'); a.style.cursor = 'default';
  });

  /* Formulare: Einordnung in den Betreff, E-Mail optional */
  $$('form.jp-form').forEach(function (f) {
    f.addEventListener('submit', function () {
      var em = f.querySelector('input[name="contact[email]"]');
      if (em && !em.value.trim()) em.value = 'ohne-email@jenny-porst.de';
      var picks = $$('input[data-jp-pick]:checked', f).map(function (i) { return i.getAttribute('data-jp-pick'); });
      var plz = f.querySelector('input[name="contact[Plz]"]'), ort = f.querySelector('input[name="contact[Ort]"]');
      var weiter = f.querySelector('input[name="contact[Weiter]"]:checked');
      var tag = weiter ? (/Vorführung/.test(weiter.value) ? '[Vorführung] ' : (/Anruf/.test(weiter.value) ? '[Rückruf] ' : (/WhatsApp/.test(weiter.value) ? '[Link per WhatsApp] ' : '[Info] '))) : '';
      var sum = f.querySelector('[data-jp-sum]');
      if (sum) sum.value = (tag + [(plz && plz.value) || '', (ort && ort.value) || ''].join(' ').trim() + (picks.length ? ', ' + picks.join(', ') : '')).trim();
    });
  });

  /* Code kopieren (Black Week: data-jp-copy="BLACK") */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-jp-copy]');
    if (!b) return;
    var t = b.getAttribute('data-jp-copy'), l = b.querySelector('[data-jp-copy-label]') || b;
    if (!l.dataset.jpOrig) l.dataset.jpOrig = l.textContent;
    function show(ok) {
      l.textContent = ok ? 'Kopiert: ' + t : 'Bitte ' + t + ' eintippen';
      clearTimeout(b._jpT); b._jpT = setTimeout(function () { l.textContent = l.dataset.jpOrig; }, 2500);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(t).then(function () { show(true); }, function () { show(false); });
    else show(false);
  });

  /* Cookie-Einstellungen (Shopify Customer Privacy) */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-jp-cookies]')) {
      if (window.privacyBanner && window.privacyBanner.showPreferences) window.privacyBanner.showPreferences();
      else location.href = '/policies/privacy-policy';
    }
  });

  /* Herkunft der Link-Seite merken (von=instagram/youtube) */
  try { var von = q.get('von'); if (von) sessionStorage.setItem('jp_von', von); } catch (e) {}
})();

/* 02.11.2026 Jenny: Inhalte nie eingeklappt. FAQ und andere Inhalts-details bleiben immer offen (Menü ausgenommen). */
(function () {
  function keepOpen() {
    document.querySelectorAll('details').forEach(function (d) {
      if (d.closest('.jp-hd') || d.classList.contains('burger') || d.classList.contains('dd')) return;
      d.open = true;
      if (!d.dataset.jpOpen) { d.dataset.jpOpen = '1'; d.addEventListener('toggle', function () { if (!d.open) d.open = true; }); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', keepOpen); else keepOpen();
})();

/* Black Week: Leiste unten, sobald der Kopf der Seite aus dem Bild ist */
(function () {
  var bar = document.querySelector('[data-bw-sticky]'), hero = document.querySelector('.jp-p-black-week .s-86');
  if (!bar || !hero || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function (e) { bar.classList.toggle('is-on', !e[0].isIntersecting); }).observe(hero);
})();
